import { useEffect } from "react";
import { setupAnimations, initAnimations } from "../utils/animations";

// This component initializes animations on the client side and reinitializes them on content changes
export function AnimationProvider() {
  useEffect(() => {
    // Initial setup
    setupAnimations();

    // Track location changes to reinitialize animations
    const handleRouteChange = () => {
      // Wait for DOM updates to complete before reinitializing animations
      setTimeout(() => {
        initAnimations();
      }, 300);
    };

    // Initialize immediately
    handleRouteChange();

    // Listen for route changes
    window.addEventListener("popstate", handleRouteChange);

    // Also reinitialize animations periodically to catch DOM updates from filtering, etc.
    const observer = new MutationObserver((mutations) => {
      // Check if any animations were affected
      const shouldReinit = mutations.some((mutation) => {
        return Array.from(mutation.addedNodes).some((node) => {
          // Check if the added node or its children might have animation attributes
          if (node.nodeType === 1) {
            // Element node
            const el = node as Element;
            // If it has data-animate attribute or has children with it
            return (
              el.hasAttribute("data-animate") ||
              el.querySelector("[data-animate]")
            );
          }
          return false;
        });
      });

      if (shouldReinit) {
        // Wait for all DOM updates to complete
        setTimeout(initAnimations, 50);
      }
    });

    // Start observing DOM changes to body
    if (typeof document !== "undefined") {
      observer.observe(document.body, { childList: true, subtree: true });
    }

    return () => {
      window.removeEventListener("popstate", handleRouteChange);
      observer.disconnect();
    };
  }, []);

  // This component doesn't render anything
  return null;
}
